import { useEffect } from 'react';

const useImportAccountDropdown = () => {
  useEffect(() => {
    const loadSharedUIComponents = async () => {
      try {
        await import('@vvoyages/shared-ui');
      } catch (error) {
        console.log('Failed to account dropdown:', error);
      }
    };

    loadSharedUIComponents();
  }, []);
};

export default useImportAccountDropdown;
